<template lang="html">
  <div class="page-section">
    <div class="container">
      <div class="youtube-videos" :class="videoClasses">
        <YouTubeVideo
          :class="{'content-bg': parse(video).boxed}"
          v-for="(video, index) in items"
          :key="`youtube-video-${index}`"
          :url="parse(video).video_url"/>
      </div>
    </div>
  </div>
</template>

<script>
import YouTubeVideo from './YouTubeVideo'
import parseComponent from '@/mixins/parseComponent'

export default {
  name: 'YouTubeVideos',

  mixins: [parseComponent],

  props: {
    currentListItem: {
      type: Object,
      description: 'This is the type of list'
    },

    items: {
      type: Array,
      description: 'The current list item'
    }
  },

  components: {
    YouTubeVideo
  },

  computed: {
    totalVideos() {
      return this.items.length
    },

    maxVideos() {
      /* If there are more than 5 videos, we'll set a new class */
      return this.totalVideos > 5
    },

    videoClasses() {
      return [
        `has-${this.totalVideos}-videos`,
        {'has-max-videos': this.maxVideos}
      ]
    }
  }
}
</script>

<style lang="sass">
@import '../../../stylesheets/base/variables'
@import '../../../stylesheets/helpers/mixins'

.youtube-videos
  @include media($media-gt-small)
    display: flex
    flex-wrap: wrap
    justify-content: center
    align-items: stretch
    align-content: stretch

    &.has-1-videos
      .youtube-video
        flex-basis: 100%

    &.has-2-videos,
    &.has-4-videos,
    &.has-5-videos,
    &.has-max-videos
      .youtube-video
        width: 50%

    &.has-3-videos
      .youtube-video
        width: percentage(1/3)

    &.has-5-videos
      .youtube-video
        &:first-child
          flex-basis: 100%
</style>
